function cycgetregsitryforgift() {
       
       if(mrRID == ''){
         return;
       }
       var dataToSend = {
         id: mrRID
      };
       
       var scriptUrl = 'https://myaccount.albeebaby.com/cyc/mod_shopifyfrontend/getregistryforgift.php?pw=1212';
        //console.log(scriptUrl);
        var result = null;
        jQuery.ajax({
            async: true,
        	type: "POST",
                dataType: "text script", 
                data: JSON.stringify(dataToSend),
        	crossDomain: true,
        	url: scriptUrl,
           success : function(text)
            {
               //result = text;
            }
          });

        return result;
}

if (typeof cycgetregsitryforgift === "function") {
  cycgetregsitryforgift(); 
}

